export default __webpack_public_path__ + "static/media/dibatiesChecker.5aef8060.jpg";